import React, { useState } from "react";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/makeRequest";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { signInWithGoogle } from "../../Firebase";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  // handleSubmit
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    apiReq(
      url.LOGIN,
      {
        username: email.toLowerCase(),
        password,
      },
      "post",
      {}
    )
      .then((res) => {
        if (res.success) {
          const userData = {
            status: true,
            token: res.data.token,
            userInfo: res.data,
          };
          localStorage.setItem("hashUser", JSON.stringify(userData));
          dispatch({
            type: "USER_LOGGEDIN",
            payload: res.success,
            token: res.data.token,
            info: res.data,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
        setIsLoading(false);
      });
  };

  return (
    <div className={"login_container"}>
      <div className={"lg:flex"}>
        <div className={"lg:w-1/3"}>
          <form className="left_part_wrapper" onSubmit={(e) => handleSubmit(e)}>
            <div className="login_form_wrapper">
              <div className={"mb-5 flex justify-center"}>
                <button
                  type={"button"}
                  className={"login-with-google-btn"}
                  onClick={signInWithGoogle}
                >
                  Sign in with Google
                </button>
              </div>
              <div className={"text-center mb-7"}>
                <span className="text-muted font-bold opacity-70">
                  or sign in with email
                </span>
              </div>
              <div className={"mb-5"}>
                <label className="form-label">Username / Email Address</label>
                <input
                  type="text"
                  className="form-control-round input"
                  placeholder="Enter your username or Email ID"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control-round input"
                  placeholder="Type Your Password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="flex justify-between mt-2">
                <div className="form-check form-check-inline"></div>
                <a className="forgot_password_label" href="#forgot-password">
                  Forgot password?
                </a>
              </div>
              <div className={"submit_button"}>
                {isLoading ? (
                  <button type="button" className="social_button w-full">
                    Loading...
                  </button>
                ) : (
                  <button type="submit" className="social_button w-full">
                    Login
                  </button>
                )}
              </div>
              <label className="social_label_footer">
                Don’t have an account? <Link to="/register">Create One</Link>
              </label>
            </div>
          </form>
        </div>
        <div className={"lg:w-2/3"}>
          <div className={"login_right_part"}></div>
        </div>
      </div>
    </div>
  );
};

export default Login;
